const hash = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom',
} as const;

type Placements = keyof typeof hash;

export default function getOppositePlacement(placement: string) {
  return placement.replace(/left|right|bottom|top/g, (matched: string) => hash[matched as Placements]);
}
